class SecurityApiService {
  constructor(HttpService, StorageService) {
    'ngInject';

    this.StorageService = StorageService;
    this.HttpService = HttpService;
  }

  login(payload) {
    return this.HttpService.post('/login', payload);
  }

  logout(payload) {
    return this.HttpService.post('/logout', payload);
  }

  saveCredentials(payload) {
    return this.HttpService.post('/' + this.StorageService.getItem('locale') + '/update-credentials', payload);
  }
  
  checkSessionExpiration() {
    return this.HttpService.post('/check-session-expiration');
  }
}

export default SecurityApiService;



// WEBPACK FOOTER //
// ./client/app/shared/security/security.api.js